/**
 * Politique de mot de passe de l'espace électricien.
 *
 * DÉLIBÉRÉMENT permissive : aucune exigence de majuscule, de minuscule, de
 * chiffre ni de symbole. Un électricien choisit le mot de passe qu'il veut —
 * les règles de composition ne faisaient qu'ajouter de la friction à des
 * utilisateurs non techniques, sans gain réel (Supabase Auth est configuré
 * avec `password_requirements = ""`, donc elles n'existaient que côté UI).
 *
 * La SEULE contrainte restante est la longueur minimale imposée par Supabase
 * Auth (`auth.minimum_password_length`). En dessous, GoTrue refuse la création
 * du compte avec une erreur brute en anglais : autant la dire nous-mêmes, dans
 * la langue de l'utilisateur, avant l'aller-retour réseau.
 *
 * ⚠️ À GARDER EN PHASE avec `supabase/config.toml` → `[auth]
 * minimum_password_length`. Descendre l'un sans l'autre fait échouer des
 * inscriptions que le formulaire annonçait pourtant valides.
 */
export const PRO_MIN_PASSWORD_LENGTH = 8;

/** Le mot de passe est-il acceptable pour un compte électricien ? */
export function isProPasswordValid(password: string): boolean {
  return password.length >= PRO_MIN_PASSWORD_LENGTH;
}
